import { queryOptions } from "@tanstack/react-query";
import { getAPI } from "../../../../api/ApiHelpers.ts";

const getCompanyWallet = async (slug) => {
  const response = await getAPI("wallet/usage", slug);
  if (response?.status) return response?.data;
};

const createCompanyWalletQuery = (slug) =>
  queryOptions({
    queryKey: ["wallet", slug],
    queryFn: () => getCompanyWallet(slug),
    retry: false,
    staleTime: Infinity,
  });

export default createCompanyWalletQuery;
